import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {SessionService} from '../../../core/service/session.service';
import {EventService} from '../../../core/service/event.service';
import {MasterService} from '../../../core/service/master.service';
import {OtherEvent} from '../../interfaces/other-event';
import {exceptKeyWithOptional, yyyyMMdd} from '../../typeAliases';
import {AbstractEventJisshiNaiyou} from '../../interfaces/abstract-event-jisshi-naiyou';

@Component({
  selector: 'app-other-event-dialog',
  templateUrl: './other-event-dialog.component.html',
  styleUrls: ['./other-event-dialog.component.scss',
    './../../layout/layout.component.scss']
})
export class OtherEventDialogComponent implements OnInit {
  selectedMeisais: OtherEvent[] = [];
  inputForm: exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'> = this.eventService.getInitialAbstractEventJisshiNaiyou();
  editEvent = false;
  edukeDate: yyyyMMdd;
  constructor(@Inject(MAT_DIALOG_DATA) public data: OtherEvent[],
              public matDialogRef: MatDialogRef<OtherEventDialogComponent>,
              public commonService: CommonService,
              public sessionService: SessionService,
              public eventService: EventService,
              public masterService: MasterService,) {
    this.edukeDate = this.data[0].taishouEdukeDate;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.selectedMeisais = this.data;
    this.eventService.setInputForm2(this.inputForm, this.selectedMeisais[0]);
    this.eventService.updateJisshiNichirei2(this.inputForm, this.edukeDate);
  }

  /**
   * その他イベント登録
   */
  register() {
    this.selectedMeisais.forEach((meisai: OtherEvent) => {
      this.eventService.inputForm2Event2(this.inputForm, meisai);
    });
    this.eventService.updateEvents(this.selectedMeisais).then(() => {
      // 成功した場合のみ true を返す
      this.commonService.onClick(this.matDialogRef);
    }).catch();
  }

  /**
   * その他イベント取り消し
   */
  undo() {
    if (confirm('実施内容を取り消しますか?')) {
      this.eventService.undoEvents(this.selectedMeisais).then(() => {
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }

  /**
   * その他イベント削除
   */
  delete() {
    if (confirm('作業を削除しますか?')) {
      this.eventService.deleteEvents(this.selectedMeisais).then(() => {
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }
}
